<template>
    <main-content>
        <div class="bg-white shadow-sm p-3 my-3" style="border-radius: 10px">
            <div class="row">
                <div class="col-sm my-2">
                    <div class="back-flex my-2">
                        <div>
                            <button
                                    @click="exportToExcel()"
                                    class="btn btn border bg-white shadow-sm mx-2 px-4 py-2"
                                    style="border-radius: 20px; border-color: #bbb"
                                    type="button"
                            >
                                <svg
                                        enable-background="new 0 0 24 24"
                                        fill="#00bea5"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        width="24"
                                        xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g>
                                        <rect fill="none" height="24" width="24"/>
                                    </g>
                                    <g>
                                        <path
                                                d="M16.59,9H15V4c0-0.55-0.45-1-1-1h-4C9.45,3,9,3.45,9,4v5H7.41c-0.89,0-1.34,1.08-0.71,1.71l4.59,4.59 c0.39,0.39,1.02,0.39,1.41,0l4.59-4.59C17.92,10.08,17.48,9,16.59,9z M5,19c0,0.55,0.45,1,1,1h12c0.55,0,1-0.45,1-1s-0.45-1-1-1H6 C5.45,18,5,18.45,5,19z"
                                        />
                                    </g>
                                </svg>
                                <span class="pr-2">خروجی اکسل</span>
                            </button>
                        </div>
                        <div class="btn-width-100">
                            <router-link class="btn btn-success my-2 btn-width-100" to="/wallets">{{ $t('label.back')
                                }}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <select
                                class="form-control kt-selectpicker"
                                id="filter_status"
                                v-model="filter_status"
                        >
                            <option :value="null" disabled selected>وضعیت</option>
                            <option :value="1" v-text="$t('label.pending')"></option>
                            <option :value="2" v-text="$t('label.success')"></option>
                            <option :value="9" v-text="$t('label.success_upcoming')"></option>
                            <option :value="3" v-text="$t('label.failed')"></option>
                            <option :value="5" v-text="$t('label.charge_pending')"></option>
                            <option :value="6" v-text="$t('label.unknown_yet')"></option>
                        </select>
                    </div>
                </div>
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <datePicker
                                clearable
                                color="#00c1a4"
                                display-format="dddd jDD jMMMM jYYYY HH:mm"
                                format="YYYY-MM-DD HH:mm:ss"
                                id="filter_from_date"
                                input-class="form-control"
                                name="filter_from_date"
                                placeholder="از تاریخ"
                                type="datetime"
                                v-model="filter_from_date"
                        />
                    </div>
                </div>
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <datePicker
                                clearable
                                color="#00c1a4"
                                display-format="dddd jDD jMMMM jYYYY HH:mm"
                                format="YYYY-MM-DD HH:mm:ss"
                                id="filter_to_date"
                                input-class="form-control"
                                name="filter_to_date"
                                placeholder="تا تاریخ"
                                type="datetime"
                                v-model="filter_to_date"
                        />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <input
                            class="form-control kt-selectpicker"
                            id="filter_transaction_hashid"
                            placeholder="شناسه تراکنش"

                            v-model="filter_transaction_hashid"
                        />

                    </div>
                </div>
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <input
                            class="form-control kt-selectpicker"
                            id="filter_dargah_transaction_id"
                            placeholder="شناسه تراکنش درگاه"

                            v-model="filter_dargah_transaction_id"
                        />

                    </div>
                </div>
                <div class="col-sm my-2">
                    <div class="form-group my-0">
                        <select
                            class="form-control kt-selectpicker"
                            id="filter_transaction_type"
                            v-model="filter_transaction_type"
                        >
                            <option :value="null" disabled selected>نوع شارژ</option>
                            <option :value="110" v-text="$t('wallets.label.charge_by_settlement_reversal')"></option>
                            <option :value="102" v-text="$t('wallets.label.charge_by_oauth2')"></option>
                            <option :value="103" v-text="$t('wallets.label.charge_by_direct_payment')"></option>
                            <option :value="104" v-text="$t('wallets.label.charge_by_transfer')"></option>
                            <option :value="105" v-text="$t('wallets.label.charge_by_bill')"></option>
                            <option :value="107" v-text="$t('wallets.label.charge_by_ivr_transaction')"></option>
                            <option :value="108" v-text="$t('wallets.label.charge_by_collective_to_wallet')"></option>
                            <option :value="109" v-text="$t('wallets.label.charge_by_marketing_profit')"></option>
                            <option :value="111" v-text="$t('wallets.label.charge_by_receipt')"></option>
                            <option :value="112" v-text="$t('wallets.label.charge_by_receipt_finally')"></option>
                            <option :value="114" v-text="$t('wallets.label.charge_by_allotment_pf_aggregate')"></option>
                            <option :value="113" v-text="$t('wallets.label.charge_by_collective_on_payment_helper_to_wallet')"></option>
                            <option :value="116" v-text="$t('wallets.label.charge_through_shaparak_settlement')"></option>
                            <option :value="114" v-text="$t('wallets.label.charge_by_deposit_with_id')"></option>
                            <option :value="115" v-text="$t('wallets.label.charge_by_deposit_with_id')"></option>
                        </select>
                    </div>
                </div>
                <div class="col-sm my-2">
                    <div class="d-flex">
                        <button
                            :class="query ? 'btn btn-success' : 'btn btn-success btn-block'"
                            @click="get_data(transactions.first_page_url)"
                            style="border-radius: 10px"
                        >
                            اعمال فیلتر
                        </button>
                        <button
                            @click="reset_and_get"
                            class="btn btn-danger mr-1"
                            style="border-radius: 10px"
                            v-if="query"
                        >
                            حذف فیلتر
                        </button>
                    </div>
                </div>

            </div>
            <div class="row my-3">
                <div class="col-md-3 my-1">
                    <div class="bg-white p-3 h-100" style="border-radius: 20px; box-shadow: 0 0 5px #8ce3d6;">
                        <p class="mx-2">مجموع شارژهای موفق</p>
                        <p class="text-center h3">{{ success_tr_amount_sum + ' ریال' }}</p>
                    </div>
                </div>
                <div class="col-md-3 my-1">
                    <div class="bg-white p-3 h-100" style="border-radius: 20px; box-shadow: 0 0 5px #8ce3d6;">
                        <p class="mx-2">تعداد شارژهای موفق</p>
                        <p class="text-center h3">{{ success_tr_count }}</p>
                    </div>
                </div>
                <div class="col-md-3 my-1">
                    <div class="bg-white p-3 h-100" style="border-radius: 20px; box-shadow: 0 0 5px #8ce3d6;">
                        <p class="mx-2">مجموع شارژ کیف به کیف موفق</p>
                        <p class="text-center h3">{{ transfer_success_tr_amount_sum + ' ریال' }}</p>
                    </div>
                </div>
                <div class="col-md-3 my-1">
                    <div class="bg-white p-3 h-100" style="border-radius: 20px; box-shadow: 0 0 5px #8ce3d6;">
                        <p class="mx-2">تعداد شارژ کیف به کیف موفق</p>
                        <p class="text-center h3">{{ transfer_success_tr_count }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-white shadow-sm py-3 my-2" style="border-radius: 10px">
            <div class="px-3">
                <div class="table-responsive">
                    <table class="table table-responsive table-borderless text-center">
                        <thead>
                        <tr>
                            <th
                                    scope="col"
                                    style="background-color: #eee; border-radius: 0 16px 16px 0"
                            >
                                شناسه
                            </th>
                            <th @click="sortBy('amount')" scope="col" style="background-color: #eee; cursor: pointer">
                                <span class="mx-2">مبلغ (ریال)</span>
                                <span v-if="sort_field == 'amount'">
                                    <span v-if="sort_sort == 'asc'">
                                      <svg
                                              fill="#00bea5"
                                              height="16"
                                              viewBox="0 0 24 24"
                                              width="16"
                                              xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M0 0h24v24H0V0z" fill="none"/>
                                        <path
                                                d="M13 19V7.83l4.88 4.88c.39.39 1.03.39 1.42 0 .39-.39.39-1.02 0-1.41l-6.59-6.59c-.39-.39-1.02-.39-1.41 0l-6.6 6.58c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L11 7.83V19c0 .55.45 1 1 1s1-.45 1-1z"
                                        />
                                      </svg>
                                    </span>
                                    <span v-else>
                                      <svg
                                              fill="#00bea5"
                                              height="16"
                                              viewBox="0 0 24 24"
                                              width="16"
                                              xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M0 0h24v24H0V0z" fill="none"/>
                                        <path
                                                d="M11 5v11.17l-4.88-4.88c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L13 16.17V5c0-.55-.45-1-1-1s-1 .45-1 1z"
                                        />
                                      </svg>
                                    </span>
                                </span>
                            </th>
                            <th @click="sortBy('status')" scope="col" style="background-color: #eee; cursor: pointer">
                                <span class="mx-2">وضعیت</span>
                                <span v-if="sort_field == 'status'">
                                    <span v-if="sort_sort == 'asc'">
                                      <svg
                                              fill="#00bea5"
                                              height="16"
                                              viewBox="0 0 24 24"
                                              width="16"
                                              xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M0 0h24v24H0V0z" fill="none"/>
                                        <path
                                                d="M13 19V7.83l4.88 4.88c.39.39 1.03.39 1.42 0 .39-.39.39-1.02 0-1.41l-6.59-6.59c-.39-.39-1.02-.39-1.41 0l-6.6 6.58c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L11 7.83V19c0 .55.45 1 1 1s1-.45 1-1z"
                                        />
                                      </svg>
                                    </span>
                                    <span v-else>
                                      <svg
                                              fill="#00bea5"
                                              height="16"
                                              viewBox="0 0 24 24"
                                              width="16"
                                              xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M0 0h24v24H0V0z" fill="none"/>
                                        <path
                                                d="M11 5v11.17l-4.88-4.88c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L13 16.17V5c0-.55-.45-1-1-1s-1 .45-1 1z"
                                        />
                                      </svg>
                                    </span>
                                </span>
                            </th>
                            <th scope="col" style="background-color: #eee">کیف</th>
                            <th scope="col" style="background-color: #eee">کارمزد</th>
                            <th scope="col" style="background-color: #eee">تاریخ ایجاد</th>
                            <th
                                    scope="col"
                                    style="background-color: #eee;"
                            >
                                نوع
                            </th>
                            <th
                                    scope="col"
                                    style="background-color: #eee; border-radius: 16px 0 0 16px"
                            >
                                توضیحات
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr :key="index" v-for="(transaction, index) in transactions.data">
                            <td class="en_num py-3">{{ transaction.id }}</td>
                            <td class="py-3">{{ transaction.amount }}</td>
                            <td class="py-3">
                  <span :class="['label label-inline' + ' label-light-' + walletTransactionStatusVariant(transaction.status)]"
                  >{{ walletTransactionStatusStr.get(transaction.status) }}</span>
                            </td>
                            <td class="py-3">{{ transaction.wallet.title }}</td>
                            <td class="py-3">{{ transaction.wage }}</td>
                            <td class="py-3">{{ transaction.created_at }}</td>
                            <td class="py-3">
                  <span :class="['label label-inline' + ' label-light-' + walletTransactionTypeVariant(transaction.type)]"
                  >{{ walletTransactionTypeStr.get(transaction.type) }}</span>
                            </td>
                            <td>
                                <div v-if="transaction.type === 104">
                                    <i @click="fetchSettlementData(transaction)" class="fas fa-info-circle" data-target="#search_modal"
                                       data-toggle="modal" style="border-radius: 20px; border-color: #bbb"
                                       type="button"></i>
                                </div>
                                <div v-else>
                                  <i @click="fetchSettlementData(transaction)" class="fas fa-info-circle" data-target="#transaction_detail"
                                     data-toggle="modal" style="border-radius: 20px; border-color: #bbb"
                                     type="button"></i>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <pagination
                    :data="transactions"
                    :get_data="get_data"
                    :perpage="perpage"
            ></pagination>
        </div>
        <div class="modal fade" id="search_modal" role="dialog" tabindex="-1" v-if="fetchSettlement !== null">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="text-center"> توضیحات</div>
                        <form class="mt-5 mx-5 mb-2">
                            <div>
                                <div class="row m-2 bg-white p-1 rounded">
                                    <div class="col-12 col-md-4 my-2">
                                        <div>{{ $t('label.transaction_type') }}</div>
                                        <input :value="fetchSettlement.type  === 'transfer' ? $t('wallets.label.charge_by_transfer'):
                                        withdrawTypeStr.get(fetchSettlement.type)"
                                               class="form-control"
                                               disabled
                                        >
                                    </div>
                                    <div class="col-12 col-md-4 my-2">
                                        <div>{{ $t('label.total_amount') }}</div>
                                        <input :value="fetchSettlement.amount"
                                               class="form-control"
                                               disabled
                                        >
                                    </div>
                                    <div class="col-12 col-md-4 my-2">
                                        <div>{{ $t('label.status') }}</div>
                                        <input :class="`form-control text-white bg-${walletTransactionStatusVariant(fetchSettlement.status)}`"
                                               :value="walletTransactionStatusStr.get(fetchSettlement.status)"
                                               disabled
                                        >
                                    </div>
                                    <div class="col-12 col-md-12 my-2"
                                    >
                                        <div>{{ $t('label.description') }}</div>
                                        <textarea :value="fetchSettlement.transfer_description"
                                                  class="form-control"
                                                  disabled
                                        ></textarea>
                                    </div>
                                </div>

                                <div>
                                    <table class="table table-bordered bg-white">
                                        <tr>
                                            <td v-text="$t('wallets.receipt.user_from')"></td>
                                            <td v-text="$t('wallets.receipt.user_to')"></td>
                                            <td v-text="$t('wallets.receipt.wallet_id_to')"></td>
                                            <td v-text="$t('wallets.receipt.wallet_id_from')"></td>
                                            <td v-text="$t('label.wallet_balance_before')"></td>
                                            <td v-text="$t('label.wallet_balance_after')"></td>
                                        </tr>
                                        <tr>
                                            <td  v-if="fetchSettlement.from">{{ fetchSettlement.from.user }}</td>
                                            <td v-if="fetchSettlement.to">{{ fetchSettlement.to.user }}</td>
                                            <td  v-if="fetchSettlement.from">{{ fetchSettlement.from.wallet_id }}</td>
                                            <td  v-if="fetchSettlement.to">{{ fetchSettlement.to.wallet_id }}</td>
                                            <td  v-if="fetchSettlement.before_balance != null">{{ fetchSettlement.before_balance }}</td>
                                            <td  v-if="fetchSettlement.after_balance != null">{{ fetchSettlement.after_balance }}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="transaction_detail" role="dialog" tabindex="-1" v-if="fetchSettlement !== null">
          <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <div class="text-center"> توضیحات</div>
                <form class="mt-5 mx-5 mb-2">
                  <div>
                    <div>
                      <table class="table table-bordered bg-white">
                        <tr>
                          <td v-if="fetchSettlement.before_balance != null" v-text="$t('label.wallet_balance_before')"></td>
                          <td v-if="fetchSettlement.after_balance != null" v-text="$t('label.wallet_balance_after')"></td>
                          <td v-if="fetchSettlement.dargah_transaction_id != null" v-text="$t('label.dargah_transaction_id')"></td>
                          <td v-if="fetchSettlement.type_code == 110">لینک تسویه</td>
                        </tr>
                        <tr>
                          <td  v-if="fetchSettlement.before_balance != null">{{ fetchSettlement.before_balance }}</td>
                          <td  v-if="fetchSettlement.after_balance != null">{{ fetchSettlement.after_balance }}</td>
                          <td  v-if="fetchSettlement.dargah_transaction_id != null">{{ fetchSettlement.dargah_transaction_id }}</td>
                          <div class="d-flex align-items-center" v-if="fetchSettlement.type_code == 110">
                            <input
                                :value="`https://my.paystar.ir/wallets/settlement-receipt/${fetchSettlement.rev_id}`"
                                class="form-control"
                                dir="ltr"
                                disabled
                                type="text"
                            />
                            <div
                                @click="
                                                          copyText(fetchSettlement)
                                                      "
                                class="
                                                          btn
                                                          m-0
                                                          pl-2
                                                          pr-0
                                                          py-1
                                                          border-success
                                                          mr-2
                                                      "
                                style="cursor: pointer"
                            >
                              <i
                                  class="
                                                              fas
                                                              fa-copy
                                                              text-success
                                                          "
                                  id="btn_copy_wallet_hashid"
                              ></i>
                            </div>
                            <a
                                class="btn m-0 px-2 py-1 border-success mx-2"
                                :href="`https://my.paystar.ir/wallets/settlement-receipt/${fetchSettlement.rev_id}`"
                                target="_blank"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#01C1A4" class="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"/>
                                <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"/>
                              </svg>
                            </a>
                          </div>
                        </tr>

                      </table>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
    </main-content>
</template>

<script>
    import mainContent from "@/components/main-content";
    import {ShopApiService, ApiUrl, walletService} from "@/common/api.service";
    import {AuthorizationHeader} from "@/common/jwt.service";
    import Pagination from "@/components/main/pagination";
    import {walletTransactionTypeStr, walletTransactionTypeVariant} from '@/constants/walletTransactionType'
    import {walletTransactionStatusStr, walletTransactionStatusVariant} from '@/constants/walletTransactionStatus'
    import {withdrawType, withdrawTypeStr} from "@/constants/withdrawType";
    import $ from "jquery";
    import Axios from "axios";
    import {i18n} from "@/plugins/i18n";

    export default {
        components: {
            mainContent,
            Pagination,
        },
        data() {
            return {
                filter_transaction_type: null,
                filter_transaction_hashid: null,
                filter_status: null,
                filter_from_date: null,
                filter_to_date: null,
                sort_field: null,
                sort_sort: "desc",
                transactions: [],
                perpage: {
                    value: 15,
                },
                walletTransactionTypeStr,
                walletTransactionStatusStr,
                walletTransactionStatusVariant,
                walletTransactionTypeVariant,
                withdrawType,
                withdrawTypeStr,
                fetchSettlement: {
                    type: '',
                    amount: '',
                    status: null,
                    transfer_description: '',
                    to: {
                        user: ''
                    },
                    collection_id: null,
                    dargah_transaction_id: null,
                },
                success_tr_count: 0,
                success_tr_amount_sum: 0,
                transfer_success_tr_amount_sum: 0,
                transfer_success_tr_count: 0,
                filter_dargah_transaction_id: null,
            };
        },
        methods: {
            copyText(text) {
              let value = `https://my.paystar.ir/wallets/settlement-receipt/${text.rev_id}`
              navigator.clipboard.writeText(
                  value
              );
              let el = document.getElementById('btn_copy_wallet_hashid');
              el.classList.remove('fa-copy');
              el.classList.add('fa-check');

              setTimeout(() => {
                el.classList.remove('fa-check');
                el.classList.add('fa-copy');
              }, 1500);
            },
            appendDataToModal(transaction, index) {
              function simpleText(data, title) {
                return '<tr><td style="width: 155px;">' + title + '</td>' +
                    '<td>' + data + '</td></tr>'
              }

              function simpleTextLtr(data, title) {
                return '<tr>' +
                    '<td style="width: 155px;">' + title + '</td>' +
                    '<td style="direction: ltr;">' + data + '</td>' +
                    '</tr>'
              }

              let transaction_detail = $('#transaction_detail').empty()
              let title = $('#title').empty()
              let ps_elements =
                  '<h4 class="modal-title float-left p-0 m-0">' +
                  i18n.t('label.detail_transaction') + '</h4>'
              title.append(ps_elements)
              ps_elements = ''
              if (transaction.before_balance && transaction.after_balance){
                ps_elements = simpleTextLtr(transaction.before_balance, i18n.t('label.wallet_balance_before'))
                transaction_detail.append(ps_elements)
                ps_elements = simpleTextLtr(transaction.after_balance, i18n.t('label.wallet_balance_after'))
                transaction_detail.append(ps_elements)
              }
            },
            exportToExcel() {
                let hashid = this.$route.params.hashid;
                let query = this.queryForExcel;
                Axios({
                    url: ApiUrl.path(`wallet/common/transactions-excel-report/${hashid}?${query}`),
                    method: "GET",
                    responseType: "blob",
                }).then((response) => {
                    let fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    let fileLink = document.createElement("a");

                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", "transactions.xlsx");
                    document.body.appendChild(fileLink);

                    fileLink.click();
                });
            },
            loadStats() {
                walletService.userGetTransactionsStats(this.$route.params.hashid, this.queryWallet).then(res => {
                    this.success_tr_count = res.data.data.success_tr_count;
                    this.success_tr_amount_sum = res.data.data.success_tr_amount_sum;
                    this.transfer_success_tr_amount_sum = res.data.data.transfer_success_tr_amount_sum;
                    this.transfer_success_tr_count = res.data.data.transfer_success_tr_count;
                });
            },
            get_data(url, callback = () => {
            }) {
                this.status = "loading";
                ShopApiService.query(url + this.query + "&perpage=" + this.perpage.value).then(
                    (json) => {
                        this.transactions = json.data.data;
                        this.status = "ok";
                        callback();
                    }
                );

                walletService.userGetTransactionsStats(this.$route.params.hashid, this.queryWallet).then(res => {
                    this.success_tr_count = res.data.data.success_tr_count;
                    this.success_tr_amount_sum = res.data.data.success_tr_amount_sum;
                    this.transfer_success_tr_amount_sum = res.data.data.transfer_success_tr_amount_sum;
                    this.transfer_success_tr_count = res.data.data.transfer_success_tr_count;
                })

            },
            sortBy(field) {
                this.sort_field = String(field);

                if (this.sort_sort == "desc") {
                    this.sort_sort = "asc";
                } else {
                    this.sort_sort = "desc";
                }

                this.get_data(this.transactions.path + "?page=1");
            },
            resetQuery() {

                this.filter_transaction_type = null;
                $('[data-id="filter_transaction_type"] .filter-option-inner-inner').text(
                    "نوع شارژ"
                );
                this.filter_transaction_hashid = null;
                $('[data-id="filter_transaction_hashid"] .filter-option-inner-inner').text(
                    "نوع شارژ"
                );

                this.filter_status = null;
                $('[data-id="filter_status"] .filter-option-inner-inner').text("وضعیت");

                this.filter_from_date = null;
                this.filter_to_date = null;
                this.sort_field = null;
            },
            reset_and_get() {
                this.resetQuery();
                this.get_data(this.transactions.path + "?page=1");
            },
            fetchSettlementData(transaction) {
                Axios.get(`wallet/ayande/settlement-detail/${transaction.id}`).then(response => {
                    this.fetchSettlement = response.data.data
                }).catch(error => {
                    throw new Error(error)
      })
    }
        },
        computed: {
            walletTransactionType() {
                return walletTransactionType
            },
            query() {
                let res = "";

                if (this.filter_transaction_type != null) {
                    res = res + "&query[transaction_type]=" + this.filter_transaction_type;
                }
                if (this.filter_transaction_hashid != null) {
                    res = res + "&query[transaction_hashid]=" + this.filter_transaction_hashid;
                }

                if (this.filter_status != null) {
                    res = res + "&query[status]=" + this.filter_status;
                }

                if (this.filter_from_date != null) {
                    res = res + "&query[from_date]=" + this.filter_from_date;
                }

                if (this.filter_dargah_transaction_id != null) {
                    res = res + "&query[dargah_transaction_id]=" + this.filter_dargah_transaction_id;
                }

                if (this.filter_to_date != null) {
                    res = res + "&query[to_date]=" + this.filter_to_date;
                }

                if (this.sort_field != null) {
                    res = res + "&sort[field]=" + this.sort_field + "&sort[sort]=" + this.sort_sort;
                }

                return res;
            },
            queryForExcel() {
                let res = "";

                if (this.filter_transaction_type != null && this.filter_transaction_type !== '') {
                    if (res !== '') {
                        res = res + '&';
                    }

                    res = res + "query[transaction_type]=" + this.filter_transaction_type;
                }
                if (this.filter_transaction_hashid != null && this.filter_transaction_hashid !== '') {
                    if (res !== '') {
                        res = res + '&';
                    }

                    res = res + "query[transaction_hashid]=" + this.filter_transaction_hashid;
                }

                if (this.filter_status != null && this.filter_status !== '') {
                    if (res !== '') {
                        res = res + '&';
                    }

                    res = res + "query[status]=" + this.filter_status;
                }

                if (this.filter_from_date != null && this.filter_from_date !== '') {
                    if (res !== '') {
                        res = res + '&';
                    }

                    res = res + "query[from_date]=" + this.filter_from_date;
                }

                if (this.filter_to_date != null && this.filter_to_date !== '') {
                    if (res !== '') {
                        res = res + '&';
                    }

                    res = res + "query[to_date]=" + this.filter_to_date;
                }

                if (this.filter_dargah_transaction_id != null) {
                    res = res + "&query[dargah_transaction_id]=" + this.filter_dargah_transaction_id;
                }

                if (this.sort_field != null && this.sort_field !== '') {
                    if (res !== '') {
                        res = res + '&';
                    }

                    res = res + "sort[field]=" + this.sort_field + "&sort[sort]=" + this.sort_sort;
                }

                return res;
            },
            queryWallet() {
                let res = "";

                res = {
                    type: this.filter_transaction_type,
                    hashid: this.filter_transaction_hashid,
                    status: this.filter_status,
                    from_date: this.filter_from_date,
                    to_date: this.filter_to_date,
                    dargah_transaction_id: this.filter_dargah_transaction_id
                }

                return res
            },
        },
        mounted() {
            this.loadStats();
            Axios.get(`wallet/common/transactions/${this.$route.params.hashid}`)
                .then((res) => {
                    this.transactions = res.data.data;
                })
                .catch((e) => {
                    console.log(e);
                });
        },
    };
</script>

<style scoped>
    .back-flex {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-end;
    }
</style>
